<template>
  <div class="all clearfix">
    <Myleft ref="left"></Myleft>
    <div class="grid newsDetail fr bgff w1070">
      <div class="grid-d">
        <div class="jianshu">
          <h2 class="ovhidden">
            <i class="tag" :class="attributeType[infoList.newsEmotion]">{{
              infoList.newsEmotion
            }}</i>
            <strong class="ml10">{{ infoList.newsTitle }}</strong>
          </h2>
          <p class="mt5 cr77">
            <span class="">{{ infoList.publishTime }}</span>
            <span
              class="collect ml20 cp"
              :class="{ curr: isFavor }"
              @click="favorites()"
              ><i class="icons collect-icon"></i> {{ favorText }}</span
            >
          </p>
          <p class="mt5 cr5e">{{ infoList.newsDigest }}</p>
          <p class="ar">
            <a class="cr27" :href="infoList.newsUrl" target="_blank"
              ><i class="icons icon-link"></i>相关链接</a
            >
          </p>
        </div>
      </div>
      <div class="grid-d mt20">
        <div class="grid-header clearfix">
          <h2 class="title">话题概况</h2>
        </div>
        <div class="grid-body mt15" v-html="hotOver">{{ hotOver }}</div>
      </div>
      <div class="grid-d mt20">
        <div class="grid-header clearfix">
          <h2 class="title">主题脉络</h2>
        </div>
        <div class="grid-body mt15">
          <ul class="eventLine">
            <div class="no-data data-load" v-if="load.timeLineList">
              <img src="static/images/loading1.gif" class="img" /><span
                class="text"
                >获取数据中...</span
              >
            </div>
            <li
              class="clearfix"
              v-for="(item, index) in timeLineList"
              :key="index"
            >
              <span class="eventLine-time cr80 fl">{{
                item.news_posttime.slice(5)
              }}</span>
              <div class="eventLine-cont">
                <div class="eventLine-title">
                  <i
                    class="tag mr6 fl"
                    :class="attributeType[item.news_emotion]"
                    >{{ item.news_emotion }}</i
                  >
                  <a
                    :href="item.news_url"
                    class="cr33 fl ovhidden ml10"
                    target="_blank"
                    :title="item.news_title"
                    >{{ item.news_title }}</a
                  >
                  <span class="icon-new ml10 fs12" v-if="index === 0"
                    >新发</span
                  >
                </div>
                <p class="mt5 ml10 cr99 fs12">
                  <span class="pr30">来源：{{ item.media_name }}</span>
                  <span class="pr30 ml20" v-if="item.news_keywords_list != ''"
                    >相关词：{{
                      item.news_keywords_list.slice(0, 3).join("，")
                    }}</span
                  >
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="grid-d mt20" v-if="newsType != 6">
        <div class="grid-header clearfix">
          <h2 class="title">传播路径</h2>
        </div>
        <div class="grid-body mt15">
          <div class="artiWrap mt20 h305 hidden tranPathBg">
            <div class="no-data" v-if="nodata.pathChart">
              <img src="static/images/no_data.png" class="img" /><span
                class="text"
                >没有数据哦...</span
              >
            </div>
            <div
              class="widget-title noborder bgcolor-panel"
              style="
                height: 100%;
                margin-top: 0px;
                overflow: hidden;
                position: relative;
                border: 0px;
              "
            >
              <div id="traceRouteDiv">
                <canvas
                  id="myCanvas"
                  class="h305"
                  style="position: absolute"
                  @click="toDetail"
                ></canvas>
              </div>
            </div>
            <!-- 展示节点数据 -->
            <div
              id="tips"
              class="widget-title noborder bgcolor-panel"
              style="
                height: 30px;
                margin-top: 0px;
                overflow-x: auto;
                position: relative;
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="grid-d" ref="box0">
        <div class="grid-header clearfix">
          <h2 class="title">话题走势</h2>
        </div>
        <div class="grid-body mt15">
          <div class="echart-warp h305">
            <lineChart
              id="hotEvent"
              :dataArray="hotEventData"
              v-if="hotEventData != ''"
              :colorArr="colorArr"
              :isShowArea="false"
              gridBot="60"
            ></lineChart>
            <div class="no-data data-load" v-if="load.hotEventData">
              <img src="static/images/loading1.gif" class="img" /><span
                class="text"
                >获取数据中...</span
              >
            </div>
            <div class="no-data" v-if="nodata.hotEventData">
              <img src="static/images/no_data.png" class="img" /><span
                class="text"
                >没有数据哦...</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="grid-d"  ref="box1">
        <div class="grid-header clearfix">
          <h2 class="title">平台分析</h2>
        </div>
        <div class="grid-body mt15">
          <div class="echart-warp h270">
            <pieChart
              id="media"
              :dataArray="mediaData"
              v-if="mediaData != ''"
              :colorArr="mediaColorArr"
            ></pieChart>
            <div class="no-data data-load" v-if="load.mediaData">
              <img src="static/images/loading1.gif" class="img" /><span
                class="text"
                >获取数据中...</span
              >
            </div>
            <div class="no-data" v-if="nodata.mediaData">
              <img src="static/images/no_data.png" class="img" /><span
                class="text"
                >没有数据哦...</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="grid-d"  ref="box2">
        <div class="grid-header clearfix">
          <h2 class="title">活跃渠道</h2>
        </div>
        <div class="grid-body mt20">
          <div class="corm clearfix">
            <span
              class="element"
              v-for="(item, index) in activeAccTab"
              :key="index"
              @click="choseAccout(index)"
              :class="{ curr: curIndex == index }"
              >{{ item }}</span
            >
          </div>
          <ul class="strip-shape clearfix">
            <li
              class="cp"
              v-for="(item, index) in activeAccList"
              :key="index"
              @click="artiView(item.name)"
            >
              <div class="people clearfix fl">
                <img
                  :src="
                    item.icon == '' ? 'static/images/head_img.png' : item.icon
                  "
                  class="img fl"
                />
                <span class="name ovhidden" :title="item.name">{{
                  item.name
                }}</span>
              </div>
              <div class="number fr">
                <span class="color-blue">{{ item.value }}</span
                >篇
              </div>
              <div class="line-warp clearfix">
                <div class="line">
                  <div
                    class="in"
                    :style="{ width: '' + item.percent + '' }"
                  ></div>
                </div>
              </div>
            </li>
          </ul>
          <div class="no-data data-load" v-if="load.activeAccList">
            <img src="static/images/loading1.gif" class="img" /><span
              class="text"
              >获取数据中...</span
            >
          </div>
          <div class="no-data" v-if="nodata.activeAccList">
            <img src="static/images/no_data.png" class="img" /><span
              class="text"
              >没有数据哦...</span
            >
          </div>
        </div>
      </div>
      <div class="grid-d"  ref="box3">
        <div class="grid-header clearfix">
          <h2 class="title">首发文章</h2>
        </div>
        <div class="grid-body pb0 mt15">
          <ul class="article-list">
            <li class="imgText clearfix">
              <!-- <router-link class="img fl cp" :to="{path:'eventDetail',query:{id:firNewsList.id}}" target="_blank"><img :src="firNewsList.icon" :onerror="defaultImg"/></router-link> -->
              <a
                class="img fl"
                :href="firNewsList.news_url"
                target="_blank"
                v-if="firNewsList.news_img_urls != undefined"
              >
                <img
                  :src="
                    firNewsList.isLoadStart
                      ? firNewsList.curImg
                      : imgChose(firNewsList, firNewsList.news_img_urls)
                  "
                  :onerror="defaultImg"
                />
              </a>
              <div class="hidden">
                <div class="clearfix mt5">
                  <h2 class="fl ovhidden2">
                    <!-- <router-link class="cr00 cp" :to="{path:'eventDetail',query:{id:firNewsList.id}}" target="_blank">{{firNewsList.news_title}}</router-link> -->
                    <a
                      class="cr00 cp"
                      :href="firNewsList.news_url"
                      target="_blank"
                      >{{ firNewsList.news_title }}</a
                    >
                  </h2>
                </div>
                <p class="cr5e mt10 ovhidden2">{{ firNewsList.news_digest }}</p>
                <p class="ziduan mt15 cr77">
                  <!-- <span v-if="firNewsList.news_source!=''">{{firNewsList.news_source}} ·  </span> -->
                  <span v-if="firNewsList.platform_name != ''"
                    ><i
                      class="icons sm-icon mr4"
                      :class="showNewType(firNewsList.news_type, 1)"
                    ></i
                    >{{ firNewsList.platform_name }} ·
                  </span>
                  <span v-if="firNewsList.media_name != ''">{{
                    firNewsList.media_name
                  }}</span>
                  <span class="ml20">{{
                    timeFilter(firNewsList.news_posttime)
                  }}</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="grid-d clearfix"  ref="box4">
        <div class="md5 fl pr10">
          <div class="grid-header clearfix">
            <h2 class="title fl">情感属性</h2>
            <div class="corm fr clearfix">
              <span
                class="element"
                :class="tuType === 'line' ? 'curr' : ''"
                @click="emotionEchartTab('line')"
                >趋势图</span
              >
              <span
                class="element"
                :class="tuType === 'pie' ? 'curr' : ''"
                @click="emotionEchartTab('pie')"
                >饼状图</span
              >
            </div>
          </div>
          <div class="grid-body mt15">
            <div class="echart-warp h270">
              <div class="no-data data-load" v-if="load.emotionData1">
                <img src="static/images/loading1.gif" class="img" /><span
                  class="text"
                  >获取数据中...</span
                >
              </div>
              <div
                class="no-data"
                v-if="tuType === 'pie' && nodata.emotionData2"
              >
                <img src="static/images/no_data.png" class="img" /><span
                  class="text"
                  >没有数据哦...</span
                >
              </div>
              <lineChart
                id="emotion1"
                :dataArray="emotionData1"
                v-if="tuType === 'line' && emotionData1 != ''"
              ></lineChart>
              <pieChart
                id="pieEchart1"
                :dataArray="emotionData2"
                :colorArr="emotionColorArr"
                v-if="tuType === 'pie' && emotionData2 != ''"
              ></pieChart>
            </div>
          </div>
        </div>
        <div class="md5 fl pl10">
          <div class="grid-header clearfix">
            <h2 class="title fl">热门主题词</h2>
            <div class="collection fr clearfix">
              <span class="tion drop-down">
                <button class="btn btn-lightblue">
                  {{ curHotTheme }}<i class="icons"></i>
                </button>
                <ul class="option">
                  <li
                    @click="hotThemeTab(index)"
                    v-for="(item, index) of mtType"
                    :key="index"
                  >
                    {{ item }}
                  </li>
                </ul>
              </span>
            </div>
          </div>
          <div class="grid-body mt15">
            <div class="echart-warp h270">
              <div class="no-data data-load" v-if="load.defaultWords">
                <img src="static/images/loading1.gif" class="img" /><span
                  class="text"
                  >获取数据中...</span
                >
              </div>
              <div class="no-data" v-if="nodata.defaultWords">
                <img src="static/images/no_data.png" class="img" /><span
                  class="text"
                  >没有数据哦...</span
                >
              </div>
              <cloudChart
                id="wordCloud"
                :dataArray="defaultWords"
                v-if="hotThemeType == 0 && defaultWords != ''"
              ></cloudChart>
              <pieChart
                v-if="hotThemeType == 1 && hotThemePie != ''"
                id="pieEchart3"
                :dataArray="hotThemePie"
                :showLegend="false"
              ></pieChart>
              <radarChart
                v-if="hotThemeType == 2 && hotThemeRadar != ''"
                id="radarEchart"
                :dataArray="hotThemeRadar"
              ></radarChart>
            </div>
          </div>
        </div>
      </div>

      <div class="grid-d clearfix"  ref="box5">
        <div class="md5 fl pr10">
          <div class="grid-header clearfix">
            <h2 class="title fl">发布地区</h2>
            <div class="collection fr clearfix">
              <span class="drop-down mores">
                <button class="btn btn-lightblue">
                  {{ curPublishArea }}<i class="icons"></i>
                </button>
                <ul class="option pl">
                  <li
                    v-for="(item, index) in areaChoseList"
                    :key="index"
                    @click="changeArea(item, 1, index)"
                  >
                    {{ item }}
                  </li>
                </ul>
              </span>
            </div>
          </div>
          <div class="grid-body mt15">
            <div class="clearfix">
              <div class="region mt20 fl">
                <div class="region-header">
                  <span class="span fl">地区</span>
                  <span class="span fl">数量</span>
                </div>
                <div class="region-body">
                  <vue-scroll :ops="ops" style="width: 140px; height: 246px">
                    <div
                      class="item"
                      v-for="(item, index) in publishAreaData"
                      :key="index"
                    >
                      <span class="span fl ovhidden">{{ item.name }}</span>
                      <span class="span fl">{{ item.value }}</span>
                    </div>
                  </vue-scroll>
                </div>
              </div>
              <div class="echart-warp hidden h270">
                <div class="no-data data-load" v-if="load.publishAreaData">
                  <img src="static/images/loading1.gif" class="img" /><span
                    class="text"
                    >获取数据中...</span
                  >
                </div>
                <mapChart
                  id="publishArea"
                  :dataArray="publishAreaData"
                  :areaName="curPublishArea"
                  v-if="publishAreaData != ''"
                  :isShowChild="false"
                ></mapChart>
              </div>
            </div>
          </div>
        </div>
        <div class="md5 fl pl10">
          <div class="grid-header clearfix">
            <h2 class="title fl">提及地区</h2>
            <div class="collection fr clearfix">
              <span class="drop-down mores">
                <button class="btn btn-lightblue">
                  {{ curMentionArea === "top" ? "全国" : curMentionArea
                  }}<i class="icons"></i>
                </button>
                <ul class="option pl">
                  <li
                    v-for="(item, index) in areaChoseList"
                    :key="index"
                    @click="changeArea(item, 2, index)"
                  >
                    {{ item }}
                  </li>
                </ul>
              </span>
            </div>
          </div>
          <div class="grid-body mt15">
            <div class="clearfix">
              <div class="region mt20 fl">
                <div class="region-header">
                  <span class="span fl">地区</span>
                  <span class="span fl">数量</span>
                </div>
                <div class="region-body">
                  <vue-scroll :ops="ops" style="width: 140px; height: 246px">
                    <div
                      class="item"
                      v-for="(item, index) in mentionAreaData"
                      :key="index"
                    >
                      <span class="span fl ovhidden">{{ item.name }}</span>
                      <span class="span fl">{{ item.value }}</span>
                    </div>
                  </vue-scroll>
                </div>
              </div>
              <div class="echart-warp hidden h270">
                <div class="no-data data-load" v-if="load.mentionAreaData">
                  <img src="static/images/loading1.gif" class="img" /><span
                    class="text"
                    >获取数据中...</span
                  >
                </div>
                <mapChart
                  id="mentionArea"
                  :dataArray="mentionAreaData"
                  :areaName="curMentionArea"
                  v-if="mentionAreaData != ''"
                  :isShowChild="false"
                ></mapChart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-d clearfix" v-if="newsType != 6"  ref="box6">
        <div class="md5 fl pr10">
          <div class="grid-header clearfix">
            <h2 class="title fl">人物实体</h2>
          </div>
          <div class="grid-body mt15 h305">
            <ul class="entity clearfix">
              <li
                class="entityLi cp"
                v-for="(item, index) in entityList"
                :key="index"
                @click="showKnow(item)"
              >
                <span>{{ item }}</span>
              </li>
            </ul>
            <div class="no-data data-load" v-if="load.entityList">
              <img src="static/images/loading1.gif" class="img" /><span
                class="text"
                >获取数据中...</span
              >
            </div>
            <div class="no-data" v-if="nodata.entityList">
              <img src="static/images/no_data.png" class="img" /><span
                class="text"
                >没有数据哦...</span
              >
            </div>
          </div>
        </div>
        <div class="md5 fl pl10">
          <div class="grid-header clearfix">
            <h2 class="title fl">机构实体</h2>
          </div>
          <div class="grid-body mt15 h305">
            <ul class="entity clearfix">
              <li
                class="entityLi cp"
                v-for="(item, index) in institEntityList"
                :key="index"
                @click="showKnow(item)"
              >
                <span>{{ item }}</span>
              </li>
            </ul>
            <div class="no-data data-load" v-if="load.institEntityList">
              <img src="static/images/loading1.gif" class="img" /><span
                class="text"
                >获取数据中...</span
              >
            </div>
            <div class="no-data" v-if="nodata.institEntityList">
              <img src="static/images/no_data.png" class="img" /><span
                class="text"
                >没有数据哦...</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="grid-d"  ref="box7">
        <div class="grid-header clearfix">
          <h2 class="title">相关文章</h2>
        </div>
        <div class="grid-body pb0 mt15">
          <ul class="article-list">
            <li
              class="imgText clearfix"
              v-for="(item, index) in commendList"
              :key="index"
            >
              <!-- <router-link class="img fl cp" :to="{path:'newsDetail',query:{id:item.id}}" target="_blank">
                                <img :src="item.isLoadStart?item.curImg:imgChose(item)" :onerror="defaultImg"/>
                            </router-link> -->
              <a class="img fl" :href="item.news_url" target="_blank">
                <img
                  :src="
                    item.isLoadStart
                      ? item.curImg
                      : imgChose(item, item.news_img_urls)
                  "
                  :onerror="defaultImg"
                />
              </a>
              <div class="hidden">
                <div class="clearfix mt5">
                  <h2 class="fl ovhidden">
                    <!-- <router-link class="cr00 cp" :to="{path:'newsDetail',query:{id:item.id}}" target="_blank">{{item.news_title}}</router-link> -->
                    <a class="cr00 cp" :href="item.news_url" target="_blank">{{
                      item.news_title
                    }}</a>
                  </h2>
                </div>
                <p class="cr5e mt10 ovhidden2">{{ item.news_digest }}</p>
                <p class="ziduan mt15 cr77">
                  <!-- <span v-if="item.news_source!=''">{{item.news_source}} ·  </span> -->
                  <span v-if="item.platform_name != ''"
                    ><i
                      class="icons sm-icon mr4"
                      :class="showNewType(item.news_type, 1)"
                    ></i
                    >{{ item.platform_name }} ·
                  </span>
                  <span v-if="item.media_name != ''">{{
                    item.media_name
                  }}</span>
                  <span class="ml20">{{ timeFilter(item.news_posttime) }}</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 预览 -->
    <Dialog
      ref="viewModal"
      :callback="enterView"
      width="720"
      title="预览"
      :modalFoot="false"
    >
      <div slot="mdBox">
        <div class="artiWrap">
          <vue-scroll :ops="ops" :style="'height:' + scrollH">
            <table
              width="100%"
              border="0"
              cellpadding="0"
              cellspacing="0"
              class="table"
            >
              <colgroup>
                <col width="100%" />
              </colgroup>
              <tbody>
                <tr v-for="(item, index) in viewList" :key="index">
                  <td>
                    <a class="ovhidden" :href="item.news_url" target="_blank">{{
                      item.news_title
                    }}</a>
                    <p class="mt10 cr77">
                      <span>{{ item.media_name }}</span>
                      <span class="ml20">{{ item.news_posttime }}</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <ul class="article-list" :style="'height:'+ scrollH">
                            <li v-for="(item,index) in viewList" :key="index">
                                <p class=" mt5"><a class="ovhidden" :href="item.news_url" target="_blank">{{item.news_title}}</a></p>
                                <p class="ziduan mt10 cr77">
                                    <span>{{item.media_name}}</span>
                                    <span>{{item.news_posttime}}</span>
                                </p>
                            </li>
                        </ul> -->
            <div class="no-data" v-if="nodata.viewList">
              <img src="static/images/no_data.png" class="img" /><span
                class="text"
                >没有数据哦...</span
              >
            </div>
          </vue-scroll>
        </div>
      </div>
    </Dialog>
    <!-- 知识图谱 -->
    <Dialog
      ref="knowModal"
      :callback="enterView"
      width="1000"
      title="知识图谱"
      :modalFoot="false"
    >
      <div slot="mdBox">
        <div class="artiWrap bg07 h800 hidden">
          <d3chart
            id="d3Svg"
            width="952"
            height="460"
            ref="d3"
            :ds="dsCharts"
            :updateDs="updateDsCharts"
            @entityFatherMethod="getEntityChild"
          ></d3chart>
          <div class="no-data mt0 pt40" v-if="nodata.knowEntity">
            <img src="static/images/no_data.png" class="img" /><span
              class="text crff"
              >啥也没有找到，换个词试试吧~</span
            >
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Myleft from "../../components/left";
import lineChart from "../../components/echart/lineChart.vue";
import pieChart from "../../components/echart/pieChart.vue";
import radarChart from "../../components/echart/radarChart.vue";
import mapChart from "../../components/echart/mapChart.vue";
import cloudChart from "../../components/echart/wordCloud.vue";
import pathChart from "../../components/echart/pathChart.vue";
import Dialog from "../../components/dialog.vue";
import d3chart from "../../components/d3Chart.vue";
import "../../../static/transPath/jquery-ui.min.js";
export default {
  components: {
    Myleft,
    lineChart,
    pieChart,
    radarChart,
    cloudChart,
    mapChart,
    Dialog,
    d3chart,
    pathChart,
  },
  data() {
    return {
      sid: this.$route.query.id,
      newsType: this.$route.query.newsType,
      type: this.$route.query.type,
      attributeType: {
        正面: "tag-blue",
        中性: "tag-orange",
        负面: "tag-red",
      }, //属性对应的class样式
      hotTopicsList: [],
      defaultImg: 'this.src="static/images/default.png"',
      nodata: {
        hotTopicsList: false,
        viewList: false,
      },
      infoList: {},
      title: "",
      beginDate: "",
      description: "",
      hotOver: "",
      timeLineList: [], //时间脉络
      pathData: [],
      hotEventData: [],
      mediaData: [],
      mediaColorArr: [
        "#30d258",
        "#e52e45",
        "#f76a44",
        "#ff8121",
        "#2475fb",
        "#1abbf0",
        "#7b37c8",
        "#6a4f77",
        "#c28000",
        "#7dbf2e",
        "#18c391",
        "#4b8abb",
        "#539e79",
        "#d216d2",
        "#bb0000",
      ],
      colorArr: [
        "#56566a",
        "#30d258",
        "#e52e45",
        "#f76a44",
        "#ff8121",
        "#2475fb",
        "#1abbf0",
        "#7b37c8",
        "#6a4f77",
        "#c28000",
        "#7dbf2e",
        "#18c391",
        "#4b8abb",
        "#539e79",
        "#d216d2",
        "#bb0000",
      ],
      curIndex: "wx",
      activeAccTab: [],
      activeAccList: [],
      wbAnalysisHtml: {},
      wbAnalysisData: [], //微博分析
      curWbType: "个人认证",
      wbTypeList: [],
      bloggerAllList: [],
      bloggerList: [], //影响力博主
      emotionData1: [], //情感属性折线
      emotionData2: [], //情感属性饼图
      tuType: "pie", //控制图表类型
      emotionColorArr: ["#0095eb", "#ff8121", "#e63349"],
      mtType: ["词云图", "饼图", "雷达图"], //媒体类别
      defaultWords: [], //热门主题词词云图
      wordColors: [
        "#3c77ce",
        "#bf3a54",
        "#2fa130",
        "#ce393a",
        "#36accd",
        "#c64c65",
      ],
      curHotTheme: "词云图",
      hotThemePie: [], //热门主题词饼图
      hotThemeRadar: [],
      hotThemeType: 0,
      publishAreaData: [], //发布地区
      areaChoseList: [],
      provinceFullList: [],
      curPublishArea: "全国",
      curPublishAllArea: "全国",
      mentionAreaData: [], //提及地区
      entityList: [], //人物实体
      institEntityList: [], //机构实体
      // isShowMap:true,
      // isShowMention:false,
      curMentionArea: "top",
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {
          keepShow: true,
        },
        bar: {
          hoverStyle: true,
          onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
          background: "#c4c4cc",
        },
      },
      gapX: 0,
      startx: 0,
      endx: 0,
      nodata: {
        timeLineList: false,
        hotTopicsList: false,
        emotionData2: false,
        defaultWords: false,
        hotEventData: false,
        mediaData: false,
        activeAccList: false,
        bloggerList: false,
        entityList: false,
        institEntityList: false,
        knowEntity: false,
        pathChart: false,
      },
      load: {
        hotTopicsList: true,
        emotionData1: true,
        emotionData2: true,
        defaultWords: true,
        hotEventData: true,
        mediaData: true,
        activeAccList: false,
        bloggerList: true,
        entityList: true,
        institEntityList: true,
        knowEntity: true,
        pathChart: true,
      },
      icons: {
        微信: "wx-icon",
        网页: "web-icon",
        微博: "wb-icon",
        头条: "toutiao-icon",
      },
      mediaList: { 全部: 4, 网页: 1, 微信: 2, 微博: 3, 头条: 5 }, //媒体列表
      commendList: [], //相关文章
      firNewsList: {
        name: "",
      }, //首发文章
      viewList: [],
      scrollH: "auto",
      dsCharts: [],
      updateDsCharts: [],
      originItem: [], //
      mediaTypeColor: [], //图例顔色
      mediaTypeName: [], //图例名称
      mediaTypeOrder: [], //图例顺序
      mediaTypeIDs: [], //显示的图例key
      isFavor: false, //是否收藏
      favorText: "收藏",
      arr: [0],
    };
  },
  mounted() {
    let that = this;
     window.addEventListener("scroll", this.handleScroll);
    that.$nextTick(() => {
      that.dataAjax();
      that.timeAjax();
      that.getData(0);
      // that.hotThemeAjax();
      // that.publishAreaAjax();
      // that.mentionAreaAjax();
    });
  },
  destroyed() {
    //注意：监听的函数要在关闭页面时销毁掉,不然会影响到其它页面
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll(e) {
          console.log(1)
      //   let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      let box_bottom = 0,
        count = 0;
      for (let i = 1; i < 8; i++) {
        //懒加载盒子高度+懒加载盒子距离顶部位置=计算出盒子底部的距离
        box_bottom =this.$refs["box" + i].offsetHeight + this.$refs["box" + i].offsetTop;

        // 可视区域+滚动条距离顶部位置 = 浏览器窗口底部的位置
        count = e.currentTarget.scrollY + document.documentElement.clientHeight;
        if (count + 200 >= box_bottom) {
          //懒加载条件限制判断
          if (this.arr.length == i) {
            this.arr[i] = i;
            //做一次判断

            this.getData(i);
            // console.log("达到加载条件，执行加载" + (i+1));
          }
        }
      }
    },
    showNewType(type, num) {
      let that = this;
      for (let key in that.mediaList) {
        if (that.mediaList[key] == type) {
          if (num == 1) {
            return that.icons[key];
          } else {
            return key;
          }
        }
      }
    },
     getData(index) {
      let that = this;
    //   that.$parent.loadModal(true, "数据加载中...");
      let datas = { sid: that.sid, news_type: that.newsType, type: that.type };
      if (index == 0) {
        //话题走势
        that.$api.get("news/info/hot-line-chart", datas, (r) => {
          that.$parent.returnCode(r, function () {
            that.load.hotEventData = false;
            that.hotEventData = r.data;
            if (r.data.length <= 0) {
              that.nodata.hotEventData = true;
              return;
            } else {
              that.nodata.hotEventData = false;
            }
          });
        });
      } else if (index == 1) {
        //媒体分析
        that.$api.get("news/info/hot-news-platform-pie", datas, (r) => {
          that.$parent.returnCode(r, function () {
            that.load.mediaData = false;
            if (r.data.length <= 0) {
              that.nodata.mediaData = true;
              return;
            } else {
              that.nodata.mediaData = false;
            }
            that.mediaData = r.data;
          });
        });
      } else if (index == 2) {
        //活跃账号
        that.$api.get("monitor/analysis/platform", datas, (r) => {
          that.$parent.returnCode(r, function () {
            if (r.data.length <= 0) {
              that.nodata.activeAccList = true;
              return;
            } else {
              that.nodata.activeAccList = false;
            }
            that.activeAccTab = r.data;
            for (let key in r.data) {
              let ele = r.data[key];
              that.curIndex = key;
              that.activeAccAjax();
              return;
            }
          });
        });
      } else if (index == 3) {
        // 首发文章
        that.$api.get("news/info/first-hotevent", datas, (r) => {
          that.$parent.returnCode(r, function () {
            // that.$parent.loadModal(false);
            r.data[0].isLoadStart = false;
            that.firNewsList = r.data[0];
            that.firNewsList.createTime = that.filter(r.data[0].createTime);
          });
        });
      } else if (index == 4) {
        //情感属性
        that.$api.get("news/info/sentiment-pie", datas, (r) => {
          that.$parent.returnCode(r, function () {
            that.load.emotionData2 = false;
            if (r.data.length <= 0) {
              that.nodata.emotionData2 = true;
              return;
            } else {
              that.nodata.emotionData2 = false;
            }
            that.emotionData2 = r.data;
          });
        });
        //热门主题词
        that.hotThemeAjax();
      } else if (index == 5) {
        //发布地区，提及地区
        that.publishAreaAjax();
        that.mentionAreaAjax();
      } else if (index == 6) {
        //人物实体
        that.$api.get("news/info/entity-analysis", datas, (r) => {
          that.$parent.returnCode(r, function () {
            that.load.entityList = false;
            that.load.institEntityList = false;
            let data = r.data;
            if (data.length <= 0) {
              that.nodata.entityList = true;
              that.nodata.institEntityList = true;
              return;
            }
            that.entityList = data.person;
            that.institEntityList = data.organization;
            if (data.person.length <= 0) {
              that.nodata.entityList = true;
            } else {
              that.nodata.entityList = false;
            }
            if (data.organization.length <= 0) {
              that.nodata.institEntityList = true;
            } else {
              that.nodata.institEntityList = false;
            }
          });
        });
      } else if (index == 7) {
        //相关文章
        that.$api.get("news/info/relate-hotevent", datas, (r) => {
          that.$parent.returnCode(r, function () {
            r.data.forEach((ele) => {
              ele.isLoadStart = false;
            });
            that.commendList = r.data;
          });
        });
      }
    },
    showNewType(type, num) {
      let that = this;
      for (let key in that.mediaList) {
        if (that.mediaList[key] == type) {
          if (num == 1) {
            return that.icons[key];
          } else {
            return key;
          }
        }
      }
    },
    hotDataAjax() {
      let that = this;
      that.$api.get("hotnews/index/tag-list-right", null, (r) => {
        that.$parent.returnCode(r, function () {
          that.hotTopicsList = r.data;
          if (r.data.list.length <= 0) {
            that.nodata.hotTopicsList = true;
          } else {
            that.nodata.hotTopicsList = false;
          }
        });
      });
    },
    dataAjax() {
      let that = this;
    //   that.$parent.loadModal(true, "数据加载中...");
      let datas = { sid: that.sid, news_type: that.newsType, type: that.type };
      //话题详情
      that.$api.get("news/info/info", datas, (r) => {
        that.$parent.returnCode(r, function () {
          that.infoList = r.data;
          if (that.infoList.isCollect == 1) {
            that.isFavor = true;
          }
          document.title = r.data.newsTitle;
        });
      });
      //话题概括
      that.$api.get("news/info/hot-over-view", datas, (r) => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.hotOver = r.data;
        });
      });

    //   //话题走势
    //   that.$api.get("news/info/hot-line-chart", datas, (r) => {
    //     that.$parent.returnCode(r, function () {
    //       that.load.hotEventData = false;
    //       that.hotEventData = r.data;
    //       if (r.data.length <= 0) {
    //         that.nodata.hotEventData = true;
    //         return;
    //       } else {
    //         that.nodata.hotEventData = false;
    //       }
    //     });
    //   });
    //   //媒体分析
    //   that.$api.get("news/info/hot-news-platform-pie", datas, (r) => {
    //     that.$parent.returnCode(r, function () {
    //       that.load.mediaData = false;
    //       if (r.data.length <= 0) {
    //         that.nodata.mediaData = true;
    //         return;
    //       } else {
    //         that.nodata.mediaData = false;
    //       }
    //       that.mediaData = r.data;
    //     });
    //   });
    //   //活跃账号
    //   that.$api.get("monitor/analysis/platform", datas, (r) => {
    //     that.$parent.returnCode(r, function () {
    //       if (r.data.length <= 0) {
    //         that.nodata.activeAccList = true;
    //         return;
    //       } else {
    //         that.nodata.activeAccList = false;
    //       }
    //       that.activeAccTab = r.data;
    //       for (let key in r.data) {
    //         let ele = r.data[key];
    //         that.curIndex = key;
    //         that.activeAccAjax();
    //         return;
    //       }
    //     });
    //   });
      //微博分析
      that.$api.get("news/info/weibo-analysis", datas, (r) => {
        that.$parent.returnCode(r, function () {
          that.wbAnalysisHtml.html = r.data.descHtml;
          that.wbAnalysisHtml.artCount = r.data.articleCount;
          that.wbAnalysisHtml.folCount = r.data.followersCount;
          that.wbAnalysisHtml.effectMax = r.data.effectMaxType;
          let wbData = {};
          wbData.datetime = r.data.keyList;
          wbData.dataName = ["辐射人群", "参与数量"];
          console.log(wbData.data);
          wbData.data = [];
          wbData.data.push(r.data.followersNumList);
          wbData.data.push(r.data.articleNumList);
          that.wbAnalysisData = wbData;
        });
      });

      //情感属性
    //   that.$api.get("news/info/sentiment-pie", datas, (r) => {
    //     that.$parent.returnCode(r, function () {
    //       that.load.emotionData2 = false;
    //       if (r.data.length <= 0) {
    //         that.nodata.emotionData2 = true;
    //         return;
    //       } else {
    //         that.nodata.emotionData2 = false;
    //       }
    //       that.emotionData2 = r.data;
    //     });
    //   });
      that.$api.get("news/info/sentiment-line", datas, (r) => {
        that.$parent.returnCode(r, function () {
          that.load.emotionData1 = false;
          that.emotionData1 = r.data;
        });
      });
      // 首发文章
    //   that.$api.get("news/info/first-hotevent", datas, (r) => {
    //     that.$parent.returnCode(r, function () {
    //       that.$parent.loadModal(false);
    //       r.data[0].isLoadStart = false;
    //       that.firNewsList = r.data[0];
    //       that.firNewsList.createTime = that.filter(r.data[0].createTime);
    //     });
    //   });
    //   //人物实体
    //   that.$api.get("news/info/entity-analysis", datas, (r) => {
    //     that.$parent.returnCode(r, function () {
    //       that.load.entityList = false;
    //       that.load.institEntityList = false;
    //       let data = r.data;
    //       if (data.length <= 0) {
    //         that.nodata.entityList = true;
    //         that.nodata.institEntityList = true;
    //         return;
    //       }
    //       that.entityList = data.person;
    //       that.institEntityList = data.organization;
    //       if (data.person.length <= 0) {
    //         that.nodata.entityList = true;
    //       } else {
    //         that.nodata.entityList = false;
    //       }
    //       if (data.organization.length <= 0) {
    //         that.nodata.institEntityList = true;
    //       } else {
    //         that.nodata.institEntityList = false;
    //       }
    //     });
    //   });
    //   //相关文章
    //   that.$api.get("news/info/relate-hotevent", datas, (r) => {
    //     that.$parent.returnCode(r, function () {
    //       r.data.forEach((ele) => {
    //         ele.isLoadStart = false;
    //       });
    //       that.commendList = r.data;
    //     });
    //   });
      that.$axios.get("static/city.json").then((r) => {
        that.areaChoseList = r.data.shortProvince;
        that.provinceFullList = r.data.province;
      });
    },
    //时间脉络
    timeAjax() {
      let that = this;
      let datas = {
        sid: that.sid,
        news_type: that.newsType,
        type: that.type,
        perpage: 100,
      };
      that.$api.get("news/info/timeline-desc", datas, (r) => {
        that.$parent.returnCode(r, function () {
          that.load.timeLineList = false;
          that.timeLineList = r.data;
        });
      });
      $("#traceRouteDiv").draggable({
        axis: "x",
      });
      that.$transPath.mediaTypeColor = {
        0: "#16A79D", //website
        1: "#F7624A", //printedMedia
        2: "#80628B", //App
        3: "#DD547A", //BBS
        4: "#CF4858", //weixin
        5: "#68B1CB", //weibo
        6: "#F5AD42", //wemedia
      };
      that.$api.get("news/info/graph-data-tree", datas, (r) => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          let data = r.data;
          let newData = [];
          let dataYCount = [];

          data.data.slice(0, 100).forEach((ele, i) => {
            //前100条，数据太多会宕机
            let tmpArr = [];
            for (let j = 0; j < ele.length; j++) {
              let dataY = ele[j];
              let px = dataY[2];
              dataY.push(0);
              if (dataY[6] > 0) {
                let num = newData[px][dataY[3]][11];
                if (num > 50) {
                  newData[px].push(["", 0, -1, -1, 0, 0, 0, 0, "", "", "", 0]);
                  tmpArr.push(["", 0, -1, -1, 0, 0, 0, 0, "", "", "", -1]);
                } else {
                  num++;
                  newData[px][dataY[3]][11] = num;
                  newData[px].push(dataY);
                  tmpArr.push(["", 0, -1, -1, 0, 0, 0, 0, "", "", "", -1]);
                }
              } else {
                tmpArr.push(dataY);
              }
            }
            newData.push(tmpArr);
          });
          let curNum = 0,
            lastCount = 0,
            lastLen = 0;
          newData.forEach((ele, i) => {
            let count = 0,
              temp = {},
              len = ele.length;
            for (let j = 0; j < ele.length; j++) {
              let dataY = ele[j];
              let px = dataY[2];
              if (dataY[11] == -1) {
                len--;
              }
              if (px != -1 || j <= 4 || dataY[4] != 0) {
                count++;
              }
            }
            if (len < 3 && lastLen > 1) {
              curNum = i;
              lastCount = 0;
            }
            temp.count = count;
            temp.hasCount = len - count;
            lastCount += len;
            lastLen = len;
            dataYCount.push(temp);
          });
          if (curNum == 0 || curNum >= newData.length - 1) {
            that.data = newData;
            that.category = data.category;
          } else {
            dataYCount[curNum - 1].hasCount = lastCount;
            that.data = newData.slice(0, curNum);
            that.data.push([]);
            let len = data.category.length;
            let lastCate = data.category[len - 1];
            that.category = data.category.slice(0, curNum);
            that.category.push("...");
            that.category.push(lastCate);
          }

          that.originItem = data.originItem;
          that.$transPath.mediaTypeName = data.mediaTypeName;
          that.$transPath.mediaTypeOrder = data.mediaTypeOrder; //图例顺序
          that.$transPath.mediaTypeIDs = data.mediaTypeOrder;
          that.$transPath.initCanvas(
            that.originItem,
            that.category,
            that.data,
            dataYCount
          );
          if (r.data.length <= 0) {
            that.nodata.treeData = true;
            return;
          } else {
            that.nodata.treeData = false;
          }
        });
      });
    },
    toDetail(e) {
      //传播详情
      let that = this;
      let details = this.$router.resolve({
        path: "/transPath",
        query: { newsUuid: this.sid, newsType: this.newsType, type: this.type },
      });
      window.open(details.href, "_blank");
    },
    timeFilter(t) {
      var newT = "";
      if (t != null) {
        let tmp = t.split(":");
        newT = tmp[0] + ":" + tmp[1];
        return newT;
      }
    },
    // 情感属性图表切换
    emotionEchartTab(type) {
      this.tuType = type;
    },
    //活跃账号切换
    choseAccout(num) {
      this.curIndex = num;
      this.activeAccAjax();
    },
    activeAccAjax() {
      let that = this;
      let data = {
        sid: that.sid,
        news_type: that.newsType,
        type: that.type,
        platform: that.curIndex,
      };
      that.activeAccList = [];
      that.nodata.activeAccList = false;
      that.load.activeAccList = true;
      that.$api.get("news/info/hot-news-media-top", data, (r) => {
        that.$parent.returnCode(r, function () {
          that.activeAccList = r.data;
          that.load.activeAccList = false;
          if (r.data.length <= 0) {
            that.nodata.activeAccList = true;
            return;
          } else {
            that.nodata.activeAccList = false;
          }
        });
      });
    },
    wordClickHandler(name, value, vm) {
      console.log("wordClickHandler", name, value, vm);
    },
    // 热门主题词切换
    hotThemeTab(type) {
      this.hotThemeType = type;
      this.curHotTheme = this.mtType[type];
    },
    // 热门主题词
    hotThemeAjax() {
      let that = this;
      that.$api.get(
        "news/info/hot-key-words",
        { sid: that.sid, news_type: that.newsType, type: that.type },
        (r) => {
          that.$parent.returnCode(r, function () {
            that.load.defaultWords = false;
            if (r.data.length <= 0) {
              that.nodata.defaultWords = true;
              return;
            } else {
              that.nodata.defaultWords = false;
            }
            that.defaultWords = r.data;
            that.hotThemePie = r.data.slice(0, 20);
            that.hotThemeRadar = r.data.slice(0, 20);
          });
        }
      );
    },
    // 发布地区
    getAreaType(data) {
      let that = this;
      // if(that.curPublishArea ==="全国" && that.areaChoseList.length===0){
      //     //that.curMentionArea = data[0].name;
      //     data.forEach(ele => {
      //         that.areaChoseList.push(ele.name);
      //     });
      //     that.areaChoseList.unshift("全国");
      // }
    },
    publishAreaAjax() {
      let that = this;
      let dataArgs = {
        sid: that.sid,
        news_type: that.newsType,
        type: that.type,
      };
      if (that.curPublishArea != "全国") {
        dataArgs.province = that.curPublishArea;
      }
      that.$api.get("news/info/publish-area", dataArgs, (r) => {
        that.$parent.returnCode(r, function () {
          that.load.publishAreaData = false;
          that.publishAreaData = r.data;
          that.getAreaType(r.data);
        });
      });
    },
    //提及地区
    mentionAreaAjax() {
      let that = this;
      let dataArgs = {
        sid: that.sid,
        news_type: that.newsType,
        type: that.type,
      };
      if (that.curMentionArea != "全国") {
        dataArgs.province = that.curMentionArea;
      }
      that.$api.get("news/info/mention-area", dataArgs, (r) => {
        that.$parent.returnCode(r, function () {
          that.load.mentionAreaData = false;
          that.mentionAreaData = r.data.data;
          that.curMentionArea = r.data.topProvince;
          that.getAreaType(r.data.data);
        });
      });
    },
    changeArea(name, type, index) {
      let that = this;
      if (type == 1) {
        that.curPublishArea = that.provinceFullList[index];
        that.publishAreaAjax();
      } else {
        that.curMentionArea = that.provinceFullList[index];
        that.mentionAreaAjax();
      }
    },
    fatherMethod(name, id, type) {
      let that = this;
      if (type == 1) {
        if (id == "publishArea") {
          that.curPublishArea = name;
          that.publishAreaAjax();
        } else {
          that.curMentionArea = name;
          that.mentionAreaAjax();
        }
      }
    },

    loadImg(ele, i, item, len, imgUrls) {
      let that = this;
      let img = new Image();
      img.src = ele;
      img.onload = function () {
        if (img.width > 200 && img.width / img.height < 3) {
          item.curImg = ele;
          item.isLoadStart = true;
          //console.log(img.width/img.height)
          return;
        }
        if (i >= len - 1) {
          item.curImg = "";
          item.isLoadStart = true;
          return;
        }
        that.loadImg(imgUrls[i + 1], i + 1, item, len, imgUrls);
      };
    },
    imgChose(item, imgUrls) {
      let that = this,
        len = imgUrls.length;
      if ((len == 1 && imgUrls[0] == "") || len == 0) {
        item.isLoadStart = true;
        item.curImg = "";
        return;
      }
      that.loadImg(imgUrls[0], 0, item, len, imgUrls);
    },
    // 详情预览
    artiView(platName) {
      let that = this;
      let query = {
        sid: that.sid,
        type: that.type,
        news_type: that.newsType,
        platform: that.curIndex,
        platform_name: platName,
      };
      that.viewList = [];
      that.$api.get("news/info/hot-news-media-top-info", query, (r) => {
        that.$parent.returnCode(r, function () {
          let data = r.data;
          that.$refs.viewModal.showMaskFun();
          that.viewList = data;
          if (data.length > 5) {
            that.scrollH = "465px";
          } else {
            that.scrollH = data.length * 80 + "px";
          }
          if (data.length <= 0) {
            that.nodata.viewList = true;
          } else {
            that.nodata.viewList = false;
          }
        });
      });
    },
    enterView() {
      let that = this;
      that.$refs.viewModal.closeMask();
    },
    //显示知识图谱
    showKnow(item) {
      let that = this;
      that.dsCharts = [];
      that.nodata.knowEntity = false;
      that.$refs.knowModal.showMaskFun();
      that.getEntity(item);
    },
    getEntity(item) {
      let that = this;
      let datas = {
        entity: item,
        sid: that.sid,
        type: that.type,
        news_type: that.newsType,
      };
      that.$api.get("news/info/knowledge-disambiguation", datas, (r) => {
        that.$parent.returnCode(r, function () {
          let data = r.data;
          if (data.length <= 0) {
            if (that.dsCharts.length <= 0) {
              that.nodata.knowEntity = true;
            }
            return;
          }
          let nodeJson = {
            nodes: [],
            links: [],
          };
          if (data[0][1] != item) {
            nodeJson.nodes.push({ name: item });
          }
          if (data.length > 0) {
            data.forEach((ele, i) => {
              if (ele[1] == "") return;
              let name = ele[1];
              if (i > 0 && ele[1] == data[i - 1][1]) {
                name = ele[1] + "(" + ele[0] + ")";
                //return
              }
              let tmp = {};
              let tmp1 = {};
              tmp.name = name;
              tmp.id = ele[2];
              nodeJson.nodes.push(tmp);
              tmp1.source = item;
              tmp1.target = name;
              tmp1.relation = ele[0];
              nodeJson.links.push(tmp1);
            });
          }
          that.dsCharts = nodeJson;
        });
      });
    },
    getEntityChild(item, id) {
      let that = this;
      let datas = {
        node_id: id,
      };
      that.$api.get("news/knowledge/node-id", datas, (r) => {
        that.$parent.returnCode(r, function () {
          let data = r.data;
          let nodeJson = {
            nodes: [],
            links: [],
          };
          if (data.length > 0) {
            data.forEach((ele, i) => {
              if (ele[1] == "") return;
              let name = ele[1];
              if (i > 0 && ele[1] == data[i - 1][1]) {
                name = ele[1] + "(" + ele[0] + ")";
                //return
              }
              let tmp = {};
              let tmp1 = {};
              tmp.name = name;
              tmp.id = ele[2];
              nodeJson.nodes.push(tmp);
              tmp1.source = item;
              tmp1.target = name;
              tmp1.relation = ele[0];
              nodeJson.links.push(tmp1);
            });
          }

          that.updateDsCharts = nodeJson;
        });
      });
    },
    favorites() {
      let that = this;
      that.isFavor = !that.isFavor;
      if (that.isFavor) {
        that.addCollect();
      } else {
        that.cancelCollect();
      }
    },
    addCollect() {
      let that = this;
      let datas = {
        sid: that.sid,
        type: that.type,
        news_type: that.newsType,
        news_sim_hash: that.infoList.newsSimHash,
        news_title: that.infoList.newsTitle,
        news_url: that.infoList.newsUrl,
        news_digest: that.infoList.newsDigest,
        news_imgs: that.infoList.newsImgs,
      };
      that.$api.post("user/collect/add", datas, (r) => {
        that.$parent.returnCode(r, function () {
          let data = r.data;
          that.$utils.alertText("收藏成功！");
          that.favorText = "已收藏";
        });
      });
    },
    cancelCollect() {
      let that = this;
      let datas = {
        type: that.type,
        news_type: that.newsType,
        news_sim_hash: that.infoList.newsSimHash,
      };
      that.$api.post("user/collect/del", datas, (r) => {
        that.$parent.returnCode(r, function () {
          let data = r.data;
          that.$utils.alertText("取消收藏成功！");
          that.favorText = "收藏";
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/news/newsDetail.vue